"use client";

import { c as _c } from "react/compiler-runtime";
import { COLLECTION_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, CREATED_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, FILTER_SIDE_PANEL_STATE_COOKIE_NAME, getDefaultFilterSidePanelState, PORTFOLIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, PROFILE_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, STATS_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, STUDIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, TOKEN_WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME, usePersona, WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME } from "@opensea/navigation";
import { useCookie } from "@opensea/ui-kit/hooks";
import { createContext, useContext } from "react";
import { LONG_LASTING_COOKIE_EXPIRATION } from "@/lib/cookie";
const FilterSidePanelContext = createContext({
  isFilterSidePanelOpen: false,
  setIsFilterSidePanelOpen: () => undefined
});
const PAGE_TO_COOKIE = {
  collection: COLLECTION_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  profile: PROFILE_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  home: FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  activity: FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  stats: STATS_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  portfolio: PORTFOLIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  watchlist: WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  "token-watchlist": TOKEN_WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  created: CREATED_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  studio: STUDIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  token: FILTER_SIDE_PANEL_STATE_COOKIE_NAME // Use the generic cookie for token pages
};
export function FilterSidePanelProvider(t0) {
  const $ = _c(8);
  const {
    children,
    page,
    filterSidePanelState: initialFilterSidePanelState
  } = t0;
  const {
    persona
  } = usePersona();
  const filterPanelCookie = PAGE_TO_COOKIE[page];
  const [filterSidePanelState, setFilterSidePanelStateCookie] = useCookie(filterPanelCookie);
  const defaultState = page === "token" ? "closed" : getDefaultFilterSidePanelState(persona);
  const resolvedFilterSidePanelOpen = (filterSidePanelState ?? initialFilterSidePanelState ?? defaultState) === "open";
  let t1;
  if ($[0] !== setFilterSidePanelStateCookie) {
    t1 = function setIsFilterSidePanelOpen(open) {
      setFilterSidePanelStateCookie(open ? "open" : "closed", {
        expires: LONG_LASTING_COOKIE_EXPIRATION
      });
    };
    $[0] = setFilterSidePanelStateCookie;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setIsFilterSidePanelOpen = t1;
  let t2;
  if ($[2] !== resolvedFilterSidePanelOpen || $[3] !== setIsFilterSidePanelOpen) {
    t2 = {
      isFilterSidePanelOpen: resolvedFilterSidePanelOpen,
      setIsFilterSidePanelOpen
    };
    $[2] = resolvedFilterSidePanelOpen;
    $[3] = setIsFilterSidePanelOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const value = t2;
  let t3;
  if ($[5] !== children || $[6] !== value) {
    t3 = <FilterSidePanelContext.Provider value={value}>{children}</FilterSidePanelContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export const useFilterSidePanel = () => {
  return useContext(FilterSidePanelContext);
};